import { grey } from '@mui/material/colors';

const theme = {
    name: 'TrunkingIO Light Theme',
    palette: {
        primary: {
            main: '#0FA3B1',
            light: '#5DD5E3',
            dark: '#007482',
        },
        secondary: {
            main: '#19857b',
        },
        tertiary: {
            main: grey[700],
            light: grey[600],
            dark: grey[800],
        },
        error: {
            main: '#980000',
        },
        background: {
            default: grey[200],
        },
        text: {
            primary: '#42424a',
        },
    },
    components: {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: 'inherit',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    textTransform: 'none',
                },
                sizeSmall: {
                    padding: '4px 6px',
                },
            },
            defaultProps: {
                disableElevation: true,
                disableRipple: true,
            },
        },
        MuiButtonGroup: {
            styleOverrides: {
                grouped: {
                    minWidth: 'auto',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    '& > .MuiSvgIcon-root': {
                        verticalAlign: 'middle',
                    },
                },
            },
        },
    },
    typography: {
        fontFamily: ['Source Sans Pro'].join(','),
        cardTitle: {
            fontSize: '1.1rem',
        },
        h1: {
            fontSize: '3.5rem',
        },
        h2: {
            fontSize: '2.7rem',
        },
        h3: {
            fontSize: '2.2rem',
        },
        h4: {
            fontSize: '1.8rem',
        },
        h5: {
            fontSize: '1.25rem',
        },
        h6: {
            fontSize: '1.1rem',
            fontWeight: 'bold',
            // color: '#42424a',
        },
        body1: {
            fontSize: '0.875rem',
        },
        subtitle1: {
            fontSize: '0.95rem',
            fontWeight: 100,
        },
        subtitle2: {
            fontSize: '0.875rem',
            fontWeight: 100,
        },
    },
};

export default theme;
